import { Header, MainBar } from '@sainsburys-tech/fable'
import React from 'react'

interface IPlannerSectionHeader {
  headerMessage: string
  className?: string
}

const ProductionPlanningHeader = ({
  headerMessage,
  className,
}: IPlannerSectionHeader) => (
  <Header className={className}>
    <div data-testid='ppHeader'>
      <div>
        <div>
          <MainBar.AppName>{headerMessage}</MainBar.AppName>
        </div>
      </div>
    </div>
  </Header>
)

export default ProductionPlanningHeader
